import { render } from "./WiseRegisterForm.vue?vue&type=template&id=5e346356"
import script from "./WiseRegisterForm.vue?vue&type=script&lang=js"
export * from "./WiseRegisterForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__